import * as React from "react";
import "./_card.scss";

const Card = (props: any) => {
	return <div className="c-card">{props.children}</div>;
};

export default Card;
